import { render, staticRenderFns } from "./m-article-text-v2.vue?vue&type=template&id=ca6d5814&scoped=true"
import script from "./m-article-text-v2.vue?vue&type=script&lang=js"
export * from "./m-article-text-v2.vue?vue&type=script&lang=js"
import style0 from "./m-article-text-v2.vue?vue&type=style&index=0&id=ca6d5814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6d5814",
  null
  
)

export default component.exports